<template>
  <loader-icon>
    <p
      v-if="chunks"
      class="loader__text-wrapper"
    >
      <span class="loader__text">
        {{ chunks.loadedCount }}
      </span>
      <span class="loader__text">/</span>
      <span class="loader__text">
        {{ chunks.totalCount }}
      </span>
    </p>
  </loader-icon>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import pinia from '../../core/pinia';
import { useEditorStore } from '../../stores';

import LoaderIcon from '../ui/LoaderIcon.vue';

const editorStore = useEditorStore(pinia);
const chunks = computed(() => editorStore.getChunks);
</script>